import { Injectable } from "@angular/core";
import { appConstants } from "../constants/appConstants";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
// import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subject } from "rxjs";
import { environment } from "../../environments/environment";
import { map, finalize } from "rxjs/operators";
import { MatDialogRef, MatDialog } from "@angular/material";
import { PaymentDetailsComponent } from "../payment/payment-initiate/payment-details/payment-details.component";
@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private _http: HttpClient // public spinner: SpinnerService
  ) {}
  userActivated = new Subject();
  login(loginCredentials: any): Observable<any> {
    let fullUrl = environment.base_url + appConstants.LOGIN_SERVICE;
    // this._loaderService.show();

    return this._http.post(fullUrl, loginCredentials);
    // .pipe(finalize(() =>
    //  this._loaderService.hide()
    //  ));
  }

  setToken(token: string): void {
    localStorage.setItem(appConstants.TOKEN_NAME, token);
  }
  getToken(): string {
    return localStorage.getItem(appConstants.TOKEN_NAME);
  }

  isLoggedIn() {
    const authToken = localStorage.getItem(appConstants.TOKEN_NAME);
    if (
      authToken !== null &&
      authToken !== undefined &&
      authToken !== "" &&
      authToken !== "undefined"
    ) {
      return true;
    }
    return false;
  }

  logOut() {
    localStorage.removeItem(appConstants.TOKEN_NAME);
    // this._router.navigateByUrl("/");
    window.location.href = environment.key_cloak_logout_url;
    this.userActivated.next("false");
  }
  public paymentDetail(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<PaymentDetailsComponent>;

    dialogRef = this.dialog.open(PaymentDetailsComponent, {
      disableClose: true,
      width: "100%",
      maxWidth: "100%",
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
}
